const t = "styles-module__description___aQARR", e = "styles-module__toggle___hM2HC", s = {
  description: t,
  toggle: e
};
export {
  s as default,
  t as description,
  e as toggle
};
